export default function BlackjackIcon({ 
  fill = "#7179A5", 
  ...props 
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg 
      width="25" 
      height="25" 
      viewBox="0 0 256 256" 
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      {...props}
    >
      <rect fill="none" height="256" width="256" />
      <path d="M232,140a56,56,0,0,1-56,56,55.2,55.2,0,0,1-25.9-6.4L162,225.5a7.8,7.8,0,0,1-1.1,7.2,7.9,7.9,0,0,1-6.4,3.3h-53a7.9,7.9,0,0,1-6.4-3.3,7.8,7.8,0,0,1-1.1-7.2l11.9-35.9A55.2,55.2,0,0,1,80,196a56,56,0,0,1-56-56C24,86.4,121.7,23.3,125.8,20.6a4.3,4.3,0,0,1,4.4,0C134.3,23.3,232,86.4,232,140Z" />
    </svg>
  );
}
